import React from "react"
import aboutImg from "../components/assets/images/about.jpg"
import { FaMoneyBillAlt, FaBookOpen, FaDownload, FaUsers } from "react-icons/fa"

export const About = () => {
  return (
    <>
    {/* Mission and Vision Section */}
    <section className='about py-3 '>
        <div className='container'>
          <h2 className='text-2xl font-semibold text-center text-black mb-6'>Our Mission & Vision</h2>

          <div className='grid grid-cols-2 gap-10 md:grid-cols-1 py-5 px-5 bg-gray-100'>
            <div className='mission'>
              <h3 className='text-xl font-semibold text-black mb-3'>Mission</h3>
              <p className='text-sm text-gray-700'>
                Our mission is to provide high-quality, practical education that fosters personal and professional growth. By equipping people with the skills and knowledge they need, we help them achieve success and excel in their careers.
              </p>
            </div>

            <div className='vision'>
              <h3 className='text-xl font-semibold text-black mb-3'>Vision</h3>
              <p className='text-sm text-gray-700'>
                Our vision is to be a global leader in professional training, empowering individuals and organizations to reach their full potential and make a positive impact in their fields.
              </p>
            </div>
          </div>
        </div>
      
        <div className='container'>
          <div className='heading text-center py-12'>
            <h1 className='text-3xl font-semibold text-black'>Why Pace Setters</h1>
            <span className='text-sm mt-2 block'>
              We offer affordable, high-quality professional training focused on excellence, integrity, and holistic development. Our programs equip individuals with the skills for career growth and emphasize ethical leadership. We believe success stems from both technical expertise and strong values. By providing industry-specific training, Pacesetters ensures learners gain practical experience to excel in their fields while fostering responsible leadership that positively impacts organizations and communities.
            </span>
          </div>

          {/* Cards Section */}
          <div className='grid grid-cols-4 gap-5 mt-5 md:grid-cols-2'>
            <AboutCard color='bg-[#2D69F0]' icon={<FaMoneyBillAlt size={50} />} title='Affordable fees' desc="Our classes are at friendly affordable rates " />
            <AboutCard color='bg-[#DD246E]' icon={<FaBookOpen size={50} />} title='High KASNEB rate' desc="Our students excel exceedingly in KASNEB exams " />
            <AboutCard color='bg-[#8007E6]' icon={<FaDownload size={50} />} title='Anytime, Anywhere Access' desc="Access our classes via android app and web" />
            <AboutCard color='bg-[#0CAE74]' icon={<FaUsers size={50} />} title='Supportive staff' desc="Our staff aim at scholarly excellence, no one is left behind " />
          </div>
        </div>
      </section>

      

      {/* Existing Content */}
      <AboutContent />
    </>
  )
}

export const AboutCard = (props) => {
  return (
    <div className={`box shadow-md p-5 py-8 rounded-md text-white ${props.color} cursor-pointer transition ease-in-out delay-150 hover:-translate-y-4 duration-300 `}>
      <div className='icon'>{props.icon}</div>
      <div className='text mt-5'>
        <h4 className='text-lg font-semibold my-3'>{props.title}</h4>
        <p className='text-sm'>{props.desc}</p>
      </div>
    </div>
  )
}

export const AboutContent = () => {
  return (
    <section className='mb-16 py-10'>
      <div className='container flex md:flex-col'>
        <div className='left w-1/3 md:w-full mr-8 md:mr-0 relative'>
          <img src={aboutImg} alt='aboutImg' className=' rounded-xl' />

        </div>
        <div className='right w-2/3 md:w-full md:mt-16'>
          <div className='heading w-4/5 md:w-full'>
            <h1 className='text-3xl font-semibold text-black'>Achieve Your Goals With us</h1>
            <span className='text-sm mt-2 block leading-6'>Pacesetters strives to be a global leader in professional training, empowering individuals and organizations to reach their full potential. Our mission is to provide high-quality, practical education that fosters personal and professional growth. By equipping people with the skills and knowledge they need, we help them achieve success and excel in their careers. Through innovative training programs, Pacesetters enables organizations to enhance productivity and performance while developing strong, ethical leaders. We are committed to shaping the future by empowering people to succeed and make a positive impact globally.
            </span>

            <button className='px-5 py-2 border border-gray-300 rounded-md text-sm'>Join Us Now</button>
          </div>
        </div>
      </div>
    </section>
  )
}
